import _ from 'lodash';
//constants
import { field, option } from '../types';
import { FormControl, TextField, FormHelperText, Autocomplete } from '@mui/material';
import { getErrorText } from '..';
import { CustomTextField } from 'theme/elements/Inputs';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

type props = {
  valid: boolean;
  cField: field;
  initialValidation: any;
  handleChange: any;
};

export default function SelectAutocomplete(props: props) {
  const t = useAppSelector(selectTranslations);
  const { valid, cField, handleChange, initialValidation } = props;
  const { name, value, label, placeholder, options, helperText, disabled, ...propsForTextField } = cField.props;
  let inputValue: { value: any; label: string } | null = null;
  let extraProps = {};
  if (_.has(cField, 'renderOption')) {
    extraProps['renderOption'] = cField.renderOption;
  }
  if (_.has(cField, 'renderInput')) {
    extraProps['renderInput'] = cField.renderInput;
  }
  if (_.has(cField, 'getOptionDisabled')) {
    extraProps['getOptionDisabled'] = cField.getOptionDisabled;
  }
  const prepareOptions = () => {
    let list: option[] = [];
    if (options?.map) {
      options.map((option) => {
        let val = cField.valueProperty ? option[cField.valueProperty] : option.value;
        let lab = cField.labelProperty ? option[cField.labelProperty] : option.label;
        inputValue = value === val ? { value: val, label: lab } : inputValue;
        list.push({
          ...option,
          value: val,
          label: lab,
        });
      });
    }
    return list;
  };
  return (
    <CustomTextField key={name}>
      <FormControl error={!valid} fullWidth sx={cField.styleObj}>
        <Autocomplete
          getOptionDisabled={(option) => !!option?.disabled}
          options={prepareOptions()}
          value={inputValue}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={(event, params) => {
            handleChange({ target: { value: params?.value, name: name } });
          }}
          disabled={disabled}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                {...propsForTextField}
                error={!valid}
                label={label}
                name={name}
                variant="outlined"
                placeholder={placeholder}
              />
            );
          }}
          {...extraProps}
        />
        <FormHelperText error={!valid}>{valid ? helperText : t(getErrorText(initialValidation, name))}</FormHelperText>
      </FormControl>
    </CustomTextField>
  );
}
